import { useState } from 'react';
import { Button, Input } from '@nazka/nazka.mapframe.components';
import { useMutation } from '@tanstack/react-query';

import Modal from '@App/components/Modal/Modal';
import PasswordInput from '@App/components/PasswordInput/PasswordInput';
import ForgotPassword from '@App/components/LoginModal/ForgotPassword/ForgotPassword.jsx';
import { signIn } from '@services/auth.service';
import { useAuth } from '@App/components/AuthProvider/auth-provider.context';

import './login-modal.css';

function LoginModal({ isOpen, setIsOpen }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);

  const { logIn } = useAuth();

  const loginMutation = useMutation({
    mutationFn: () => signIn({ email, password }),
    onSuccess: () => {
      logIn();
      setIsOpen(false);
    },
  });

  if (forgotPassword && isOpen) {
    return (
      <ForgotPassword
        onClose={() => setIsOpen(false)}
        goBack={() => setForgotPassword(false)}
      />
    );
  }

  return (
    <Modal
      title="Aanmelden"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      closeOnOverlayClick={false}
      className="login-modal"
    >
      <div className="login-modal__form">
        <label className={`login-modal__form__label${(emailError || loginMutation.isError) ? ' login-modal__form__label--error' : ''}`}>
          <span className="login-modal__form__label__text">
            Email
          </span>
          <Input
            className="login-modal__form__label__input"
            value={email}
            onInputChange={(v) => {
              setEmail(v.target.value);
              setEmailError(false);
            }}
            rootElProps={{ onSelect: () => setEmailError(false), placeholder: 'Email' }}
          />
        </label>
        <label className={`login-modal__form__label${(passwordError || loginMutation.isError) ? ' login-modal__form__label--error' : ''}`}>
          <span className="login-modal__form__label__text">
            Wachtwoord
          </span>
          <PasswordInput
            className="login-modal__form__label__input"
            value={password}
            onInputChange={(value) => {
              setPassword(value);
              setPasswordError(false);
            }}
            onSelect={() => setPasswordError(false)}
            placeholder="Wachtwoord"
          />
        </label>
      </div>
      <Button
        className="login-modal__forgot-password-button"
        layout="ghost"
        hover={false}
        onClick={() => setForgotPassword(true)}
      >
        Wachtwoord vergeten?
      </Button>
      <Button
        className="login-modal__submit-button"
        onClick={() => {
          if (!email.length) setEmailError(true);
          if (!password.length) setPasswordError(true);
          if (email.length && password.length) loginMutation.mutate();
        }}
        isLoading={loginMutation.isPending}
      >
        Aanmelden
      </Button>
    </Modal>
  );
}

export default LoginModal;
